import { Provider } from "react-redux";
import { setupStore } from "../store/store";

import React, { ReactNode } from "react";

export const StoreProvider = ({ children }: { children: ReactNode }) => (
  <Provider store={setupStore({})}>{children}</Provider>
);
